/**
 * ATOM LED — Announce bar rotator (mobile only)
 *
 * On viewports ≤768px, fades through .xp-announce__item siblings every
 * 3 seconds. On larger viewports, the desktop CSS shows all items in a
 * row and this script does nothing.
 *
 * Respects prefers-reduced-motion: cycles instantly with no fade if user
 * has motion disabled.
 *
 * Pauses when the page is hidden (tab in background) so we don't burn
 * cycles when no one's looking.
 */
(function () {
  'use strict';

  const ROTATION_MS = 3000;
  const FADE_MS = 280;
  const MOBILE_QUERY = '(max-width: 768px)';

  function init() {
    const center = document.querySelector('.xp-announce__center');
    if (!center) return;
    const items = Array.from(center.querySelectorAll('.xp-announce__item'));
    if (items.length < 2) return;

    let index = 0;
    let timer = null;
    let mediaList = null;

    function setActive(i) {
      items.forEach((el, idx) => {
        el.classList.toggle('is-active', idx === i);
      });
    }

    function tick() {
      index = (index + 1) % items.length;
      setActive(index);
    }

    function start() {
      if (timer) return;
      setActive(index);
      timer = window.setInterval(tick, ROTATION_MS);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
      // Strip rotation classes — desktop layout shows everything inline.
      items.forEach((el) => el.classList.remove('is-active'));
    }

    function syncToViewport() {
      if (mediaList && mediaList.matches) {
        start();
      } else {
        stop();
      }
    }

    // Pause when tab not visible.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        if (timer) window.clearInterval(timer);
        timer = null;
      } else {
        syncToViewport();
      }
    });

    // Listen for viewport changes (rotate phone, resize, dev tools).
    mediaList = window.matchMedia(MOBILE_QUERY);
    if (mediaList.addEventListener) {
      mediaList.addEventListener('change', syncToViewport);
    } else if (mediaList.addListener) {
      mediaList.addListener(syncToViewport);
    }

    syncToViewport();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
